export default "__VITE_ASSET__DeabGzeZ__"